/* ==========================================================================
   LUJE — hide a colour swatch on a collection-page product card when that
   colour has zero available combinations left (every size sold out).

   THE GAP THIS FILLS
   Minimog's own card-availability logic explicitly skips card view:
   app.min.js's hideSoldoutAndUnavailableOptions() opens with
   `if ("card" === this.view) return;` — cards always render every colour as
   if fully in stock, regardless of real inventory. That's a deliberate
   choice in the base theme for the PDP-vs-card distinction, but it means a
   100%-dead colourway (e.g. Pulse baggy lyocell pants' Black, 0 stock across
   all 7 sizes) still shows a normal, clickable-looking swatch dot on the
   collection grid.

   HOW IT KNOWS WHAT'S AVAILABLE
   Reuses data that already exists on every card for a different feature
   (luje-filter-availability.js): snippets/product-card.liquid emits a
   <script type="application/json" data-luje-variant-availability="{{ id }}">
   containing every currently-available variant's option values (colour AND
   size mixed together, e.g. {"color":"Army","size":"XXS"}). That script tag
   and the card markup are rendered as strict siblings in that order for
   every product in the loop (product-card.liquid:90, then the card-style
   render just after) — so nextElementSibling reliably pairs one card with
   its own availability data, no product-id matching needed, and no risk of
   cross-matching if the same product appears twice on one page (e.g. also
   in a "you may also like" rail).

   Values are compared case-insensitively and pooled from every option key,
   not just "colour" specifically — a coincidental collision between a size
   value and a colour value never happens in practice, so this avoids having
   to know or guess which option is the colour one.

   Static, one-time check per page load: cards have no interactive "current
   selection" the way the PDP does, so there's nothing to keep in sync after
   the initial render.
   ========================================================================== */
(function () {
  'use strict';

  function run() {
    var scripts = document.querySelectorAll('[data-luje-variant-availability]');
    for (var i = 0; i < scripts.length; i++) {
      var script = scripts[i];
      var card = script.nextElementSibling;
      if (!card) continue;

      var swatches = card.querySelectorAll('.product-option-item[data-option-type="color"]');
      if (!swatches.length) continue;

      var data;
      try {
        data = JSON.parse(script.textContent || '[]');
      } catch (e) {
        continue;
      }

      var available = {};
      for (var j = 0; j < data.length; j++) {
        var entry = data[j];
        for (var key in entry) {
          if (Object.prototype.hasOwnProperty.call(entry, key)) {
            available[String(entry[key]).toLowerCase()] = true;
          }
        }
      }

      for (var k = 0; k < swatches.length; k++) {
        var sw = swatches[k];
        var value = (sw.getAttribute('data-value') || '').toLowerCase();
        if (value && !available[value]) {
          sw.classList.add('luje-card-soldout');
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
